<div class="card border-0 rounded-3 shadow mb-3">
  <div class="card-body">
    <div class="d-flex justify-content-between align-items-center mb-3">
      <div class="paginator-container" *ngIf="totalCount && showPaginator">
        <app-paginator (nextPage)="handleNextPage($event)" [totalCount]="totalCount" [page]="page"></app-paginator>
      </div>
      <span class="text-aln-center" *ngIf="showDownloadBtn && applicationListData.length > 0">
        <b>Note</b>:To download list details, first click on 'Generate CSV' to start processing.<br>
        Then, check 'CSV Status' for the file's progress and download once ready.
      </span>
      <div class="ms-auto img-fluid d-flex flex-row" *ngIf="showDownloadBtn && applicationListData.length > 0"
        style="cursor: pointer">
        <div
          style="background-color: #2DBE5A; color: white; width: 140px; height: 35px; border: none;border-radius: 4px; display: grid; place-items: center; margin-left: 10px;"
          *ngIf="applicationListData.length > 0" alt="Download" (click)="downloadCsvButton()">
          <span>Generate CSV</span>
        </div>
        <!-- <img src="../../../assets/icons/download.svg" alt="Download" (click)="downloadCsvButton()" /> -->
        <div *ngIf="showCsvList" style="
            background-color: #2dbe5a;
            color: white;
            width: 140px;
            height: 35px;
            border: none;
            border-radius: 4px;
            display: grid;
            place-items: center;
            margin-left: 10px;
          " (click)="redirectDownloadCsvList()">
          <span>CSV List</span>
        </div>
      </div>
    </div>
    <div class="table-responsive">
      <table class="table table-borderless main-table" style="border: 1px solid #ddd;">
        <thead class="">
          <th class="border-0 fs-14" *ngIf="tableHeader.length > 0"
            style="text-align: center;border: 1px solid #ddd !important; ">S.No.</th>
          <th class="border-0 fs-14" *ngFor="let header of tableHeader"
            style="text-align: center;border: 1px solid #ddd  !important;">
            {{ header?.label }}
          </th>
        </thead>
        <tbody>
          <tr class="border-bottom fs-10" *ngFor="let item of applicationListData; let i = index">
            <td class="" width="10">{{ sNumberPage * 20 + i + 1 }}</td>
            <td *ngFor="let header of tableHeader" [ngClass]="{'app-no pointer':header?.drill 
            && ['stateName','district_name','block_name','geoName','bankName'].includes(header.key)}" (click)=" header?.drill && [ 'stateName',  'district_name', 'block_name',  'geoName',  'bankName' ].includes(header.key) 
            && nestedDrill(header, item)" style="min-width: 140px;border: 1px solid #ddd;" [ngStyle]="{
              'text-align': header.type === 'number' || header.type === 'amount' 
                ? 'right'  : header.type === 'button'  ? 'center'   : 'left'}">
              <ng-container *ngIf="header.key !== 'applicationType'; else applicationTypeTemplate">
                <ng-container *ngIf="header.key !== 'reportStatus';else reportStatusTemplate">
                  <ng-container *ngIf="header.key !== 'applicationStatus';  else applicationStatusTemplate">
                    <ng-container [ngSwitch]="header.type">

                      <span *ngSwitchCase="'amount'">
                        <!-- {{ item[header.key] | currency : "INR" }} -->
                        {{ item[header.key]| indianCurrency }}
                      </span>
                      <span *ngSwitchCase="'number'">
                        <!-- {{ item[header.key] | currency : "INR" }} -->
                        {{ item[header.key]| indianNumberWithoutDecimal }}
                      </span>
                      <span *ngSwitchCase="'pdfView'" class="app-no pointer" (click)="openPdfView(item)">
                        {{ item[header.key] }}
                      </span>
                      <span *ngSwitchCase="'date'">
                        {{ item[header.key] | date : "dd/MM/yy" }}
                      </span>
                      <span *ngSwitchCase="'button'">
                        <ng-container *ngIf="header.buttonLabel === 'Download';  else notDownloadBtn">
                          <button [class]="header.class" (click)="action(item, i)" *ngIf="item.reportStatus === 2 ">
                            {{ item[header.key] || header.buttonLabel }}
                          </button>
                        </ng-container>
                        <ng-template #notDownloadBtn>
                          <button [class]="header.class" (click)="action(item, i)">
                            {{ item[header.key] || header.buttonLabel }}
                          </button>
                        </ng-template>
                      </span>
                      <span *ngSwitchDefault>{{ item[header.key] }}</span>
                    </ng-container>
                  </ng-container>
                </ng-container>
              </ng-container>

              <ng-template #applicationStatusTemplate>
                <span>item[header.key]</span>
                <ng-container [ngSwitch]="item[header.key]">
                  <span *ngSwitchCase="1">Pending</span>
                  <span *ngSwitchCase="2">Under Review</span>
                  <span *ngSwitchCase="3">Sanctioned</span>
                  <span *ngSwitchCase="4">Rejected</span>
                  <span *ngSwitchCase="5">Pulled</span>
                  <span *ngSwitchCase="6">Withdraw</span>
                  <span *ngSwitchCase="7">Draft</span>
                  <span *ngSwitchDefault>Unknown Status</span>
                </ng-container>
              </ng-template>

              <ng-template #applicationTypeTemplate>
                <ng-container [ngSwitch]="item[header.key]">
                  <span *ngSwitchCase="1">Fresh</span>
                  <span *ngSwitchCase="2">Renewal</span>
                  <span *ngSwitchCase="3">Enhanced</span>
                  <span *ngSwitchDefault>Unknown Type</span>
                </ng-container>
              </ng-template>

              <ng-template #reportStatusTemplate>
                <ng-container [ngSwitch]="item[header.key]">
                  <span *ngSwitchCase="1">Pending</span>
                  <span *ngSwitchCase="2">Completed</span>
                  <span *ngSwitchCase="3">Failed</span>
                  <span *ngSwitchCase="4">Downloaded</span>
                  <span *ngSwitchDefault>Unknown</span>
                </ng-container>
              </ng-template>

              <img *ngIf="header.type == 'view'" src="..//assets/icons/visibility_black_24dp.svg" alt="view icon"
                (click)="viewData(item, 'view')" style="margin-left: 30%; cursor: pointer" />
            </td>
          </tr>

          <tr class="border-0 fs-14" style="background-color: #f8f9fa" *ngIf="totalAmounts">
            <td><b>Total</b></td>
            <td *ngFor="let header of tableHeader" style="border: 1px solid #ddd;"
              [ngStyle]="{ 'text-align': (header.type === 'number' || header.type === 'amount') ? 'right' : 'left' }">
              <ng-container [ngSwitch]="header.type">
                <ng-container *ngSwitchCase="'amount'">
                  <ng-container *ngIf="totalAmounts[header.key] !== undefined">
                    <!-- {{ totalAmounts[header.key] | currency : "INR" }} -->
                    <b>{{ totalAmounts[header.key] | indianCurrency }}</b>
                  </ng-container>
                  <ng-container *ngIf="totalAmounts[header.key] == undefined">
                  </ng-container>
                </ng-container>
                <ng-container *ngSwitchCase="'number'">
                  <ng-container *ngIf="totalAmounts[header.key] !== undefined">
                    <!-- {{ totalAmounts[header.key] | currency : "INR" }} -->
                    <b>{{ totalAmounts[header.key] | indianNumberWithoutDecimal }}</b>
                  </ng-container>
                  <ng-container *ngIf="totalAmounts[header.key] == undefined">
                  </ng-container>
                </ng-container>
                <ng-container *ngSwitchDefault>
                  <b>{{
                    totalAmounts[header.key] != undefined
                    ? totalAmounts[header.key]
                    : ""
                    }}</b>
                </ng-container>
              </ng-container>
            </td>
          </tr>
        </tbody>
      </table>
      <div class="border-bottom fs-10" style="display: grid; place-items: center"
        *ngIf="!applicationListData || applicationListData?.length == 0">
        <h5>No Data Found ☹</h5>
      </div>
    </div>
  </div>
</div>